module.exports = __webpack_public_path__ + "static/img/bg-es.19051e83.png";